// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"47":"151d2321985633934f7d","174":"a5da79445c44190e34a7","284":"a40aab70e0122eac2d19","832":"f90c558efbee0bff8fd4","859":"493836a89921b7b41499"}[chunkId] + ".js";
};